import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

interface Props {
  onRefresh: () => Promise<void>;
  isRefreshing: boolean;
  children: React.ReactNode;
}

export const PullToRefresh: React.FC<Props> = ({
  onRefresh,
  isRefreshing,
  children,
}) => {
  const [startY, setStartY] = useState<number | null>(null);
  const [pulling, setPulling] = useState(false);

  useEffect(() => {
    if (!isRefreshing && pulling) {
      setPulling(false);
    }
  }, [isRefreshing, pulling]);

  const handleTouchStart = (e: React.TouchEvent) => {
    if (window.scrollY === 0) {
      setStartY(e.touches[0].clientY);
    }
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (startY !== null) {
      const pull = e.touches[0].clientY - startY;
      if (pull > 50) {
        setPulling(true);
      }
    }
  };

  const handleTouchEnd = async () => {
    if (pulling && !isRefreshing) {
      await onRefresh();
    }
    setStartY(null);
  };

  return (
    <Box
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {children}
    </Box>
  );
};
